<template>
  <NotificationBar ref="notificationBar"/>
  <UserBarVue/>
  <h1>Use the form below to create a user account.</h1>
  <h3>If adding another user for a film lab account you will need to log into the film lab admin account and add a user from the overview page.</h3>

  <div id="input-form">
    <div class="FRNW" style="justify-content: center;">
      <input type="checkbox" v-model="isLabAccount">
      <label for="">Lab Account?</label>
      <InfoVue
        :title="'Check if you are creating an account for your film lab. IE you have a business you are setting up.'"
      />
    </div>


    <!-- SECTION FOR GENERIC USER ACCOUNTS -->
    <div>
      <div>
        <input v-model="firstName" type="text" name="first-name" placeholder="First name" required>
      </div>
      <div>
          <input v-model="lastName" type="text" name="last-name" placeholder="Last name" required>
      </div>
      <div>
        <input v-model="email" type="email" name="email" placeholder="Email" required>
      </div>
      <div>
        <input v-model="address.street" type="text" name="street-number-name" placeholder="Street number/name">
      </div>
      <div>
        <input v-model="address.apartmentNumber" type="text" name="apartment-number" placeholder="Apartment number">
      </div>
      <div>
        <input v-model="address.city" type="text" name="city" placeholder="City">
      </div>
      <div>
        <input v-model="address.state" type="text" name="state" placeholder="State">
      </div>
      <div>
        <input v-model="address.zipCode" type="text" name="zip-code" placeholder="Zip code">
      </div>
      <div>
        <input v-model="pw1" type="password" name="password" placeholder="Password" required>
      </div>
      <div>
        <input v-model="pw2" type="password" name="verify-password" placeholder="Verify password" required>
      </div>
      <button 
        :disabled="!canSubmit" 
        type="submit"
        @click="createUser()"
      >
        Create User
      </button>

    </div>

  </div>
</template>

<script>

import NotificationBar from '../components/NotificationBar.vue';
import InfoVue from '@/components/basicComponents/Info.vue';
import UserBarVue from '../components/basicComponents/UserBar.vue';
import { Encrypt, ValidateEmail } from '../utils';

const API = process.env.VUE_APP_API_URL;
let NOTIFICATION, FLA_AXIOS;

export default {
  name: 'CreateUser',
  components: {
    NotificationBar,
    InfoVue,
    UserBarVue,
  },
  data() {
    return {
      isLabAccount: false,
      firstName: '',
      lastName: '',
      email: '',
      address: {
        street: '',
        apartmentNumber: '',
        city: '',
        state: '',
        zipCode: '',
      },
      pw1: '',
      pw2: '',
    }
  },
  computed: {
    canSubmit() {
      const pwsMatch = this.pw1 === this.pw2;
      const pwNotEmpty = this.pw1 !== '';
      const validEmail = ValidateEmail( this.email );

      return  pwsMatch && pwNotEmpty && validEmail;
    }
  }, 
  methods: {

    createUser() {
      const data = {
        userName: `${this.firstName}${this.lastName}`,
        firstName: this.firstName,
        lastName: this.lastName,
        address: this.address,
        password: Encrypt( this.pw1 ),
        email: this.email,
        isLabAccount: this.isLabAccount,
      };

      FLA_AXIOS('post', API + '/api/user/create', data)
      .then( res => {
        NOTIFICATION.showNotification( res.data );

        // reset input fields
        if ( res.data?.notification?.type !== error ) {
          this.isLabAccount = false;
          this.firstName = '';
          this.lastName = '';
          this.email = '';
          this.address = {
            street: '',
            apartmentNumber: '',
            city: '',
            state: '',
            zipCode: '',
          };
          this.pw1 = '';
          this.pw2 = '';
        }
      } )
      .catch( e => console.error(e) )
    },

  },
  mounted() {
    NOTIFICATION = this.$refs.notificationBar;
    FLA_AXIOS = window.FLA_Axios;
  }
}
</script>